import { useState, useCallback } from 'react';

const useToggle = (initial) => {
  const [on, setOn] = useState(initial);

  return [on, useCallback(() => setOn(isOn => !isOn))];
};

export default useToggle;
